import React from 'react';
import PropTypes from 'prop-types';
import ScriptSandbox from 'components/utilities/ScriptSandbox';

const BookATableWidget = ({ id, baseColor = '#d1eef6', language = 'null' }) => (
  <ScriptSandbox
    style={{ width: 310 }}
    content={`
     <script type="text/javascript" src="https://bda.bookatable.com/deploy/lbui.direct.min.js"></script>
     <script type="text/javascript">
         LBDirect_Embed({
             connectionid: "NO-VISITOSLO:80497",
             restaurantid: ${id},
             language: ${language},
             style: {
                 baseColor: '${baseColor}'
             }
         });
     </script>
 `}
  />
);
BookATableWidget.propTypes = {
  id: PropTypes.any,
  baseColor: PropTypes.any,
  language: PropTypes.any,
};

export default BookATableWidget;
